import { useState } from "react";
import poster from "@/assets/cobrain-spoof-poster.jpg";
import { PALETTE, FONT_DISPLAY, FONT_MONO } from "./tokens";

const VIDEO_URL =
  "https://dvddfvigkzikieuqrtcn.supabase.co/storage/v1/object/public/marketing-media/cobrain/hiring-claude-spoof.mp4";

export const SpoofVideo = () => {
  const [playing, setPlaying] = useState(false);

  return (
    <div
      style={{
        marginTop: 28,
        background: "rgba(255,255,255,0.04)",
        border: "1px solid rgba(255,255,255,0.08)",
        borderRadius: 20,
        padding: "clamp(20px, 3vw, 32px)",
        display: "grid",
        gridTemplateColumns: "minmax(0, 1.1fr) minmax(0, 1fr)",
        gap: "clamp(20px, 3vw, 36px)",
        alignItems: "center",
      }}
      className="cb-spoof-card"
    >
      <style>{`
        @media (max-width: 760px) {
          .cb-spoof-card { grid-template-columns: 1fr !important; }
        }
      `}</style>

      <div
        style={{
          position: "relative",
          borderRadius: 14,
          overflow: "hidden",
          border: "1px solid rgba(255,255,255,0.1)",
          background: "#000",
          aspectRatio: "16 / 9",
        }}
      >
        <video
          controls={playing}
          preload="metadata"
          playsInline
          poster={poster}
          onPlay={() => setPlaying(true)}
          style={{ width: "100%", height: "100%", display: "block", objectFit: "cover", background: "#000" }}
        >
          <source src={VIDEO_URL} type="video/mp4" />
        </video>

        {!playing && (
          <button
            type="button"
            aria-label="Play video"
            onClick={(e) => {
              const v = e.currentTarget.parentElement?.querySelector("video") as HTMLVideoElement | null;
              if (v) { v.play(); setPlaying(true); }
            }}
            style={{
              position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center",
              background: "linear-gradient(180deg, rgba(0,0,0,0.10) 0%, rgba(0,0,0,0.45) 100%)",
              border: "none", cursor: "pointer", color: "#fff",
            }}
          >
            <span
              style={{
                width: 68, height: 68, borderRadius: "50%",
                background: PALETTE.amber, display: "flex", alignItems: "center", justifyContent: "center",
                boxShadow: "0 12px 40px -8px rgba(196,130,58,0.7)",
              }}
            >
              <svg width="26" height="26" viewBox="0 0 24 24" fill="#fff" aria-hidden>
                <path d="M8 5v14l11-7z" />
              </svg>
            </span>
          </button>
        )}
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <div style={{
          display: "inline-flex", alignItems: "center", gap: 8, alignSelf: "flex-start",
          padding: "4px 10px", borderRadius: 999,
          background: "rgba(196,130,58,0.14)",
          border: "1px solid rgba(196,130,58,0.32)",
          fontFamily: FONT_MONO, fontSize: 10.5, letterSpacing: "0.14em",
          textTransform: "uppercase", color: PALETTE.amberSoft, fontWeight: 700,
        }}>
          <span style={{ width: 6, height: 6, borderRadius: "50%", background: PALETTE.amber }} />
          Intermission · 60 sec
        </div>
        <h3 style={{
          fontFamily: FONT_DISPLAY, fontWeight: 400,
          fontSize: "clamp(26px, 3vw, 36px)", lineHeight: 1.08, letterSpacing: "-0.01em",
          margin: 0, color: "#fff",
        }}>
          Or you could just…{" "}
          <em style={{ color: PALETTE.amberSoft }}>hire Claude.</em>
        </h3>
        <p style={{
          margin: 0, fontSize: 15, lineHeight: 1.55,
          color: "rgba(255,255,255,0.7)",
        }}>
          A short film about what "just plug in an AI" actually looks like at the office.
        </p>
      </div>
    </div>
  );
};

export default SpoofVideo;
